import {
    SupportedSubscriptionsProvider,
    ModularSubscriptionsElements,
    SupportedPaymentsProvider,
} from './types';
import { CleengPurchaseScreen } from '../../components/Cleeng/ModularScreens/CleengPurchaseScreen';
import { CleengPaymentMethodScreen } from '../../components/Cleeng/ModularScreens/CleengPaymentMethodScreen';
import { CleengPaymentHistoryScreen } from '../../components/Cleeng/ModularScreens/CleengPaymentHistoryScreen';
import { CleengProvider } from '../CleengProvider';
import { StripePaymentMethod } from '../../components/Stripe/screens/StripePaymentMethod/index.web';
import { StripePurchase } from '../../components/Stripe/screens/StripePurchase/index.web';
import { StripePaymentHistory } from '../../components/Stripe/screens/StripePaymentHistory/index.web';
import { StripeProvider } from '../StripeProvider';

export const subscriptionProviderElementsMap: Record<
    SupportedSubscriptionsProvider,
    ModularSubscriptionsElements
> = {
    cleeng: {
        PurchaseScreen: CleengPurchaseScreen,
        PaymentMethodScreen: CleengPaymentMethodScreen,
        PaymentHistoryScreen: CleengPaymentHistoryScreen,
        ConfigProvider: CleengProvider,
    },
};

export const paymentProviderElementsMap: Record<
    SupportedPaymentsProvider,
    ModularSubscriptionsElements
> = {
    stripe: {
        PurchaseScreen: StripePurchase,
        PaymentMethodScreen: StripePaymentMethod,
        PaymentHistoryScreen: StripePaymentHistory,
        ConfigProvider: StripeProvider,
    },
};
